import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import './shimmer.scss';

function Shimmer({ isMob }) {
  return (
    <div className="dashboard-body dashboard-shimmer">
      <div className="web-hide">
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={360}
          height={120}
          sx={{ background: '#fafafa' }} />
      </div>

      <div className="portifolio-container">
        <div
          className="impact-summary"
          style={{ backgroundColor: '#EBFAFA', padding: '20px 20px 0 20px' }}>
          <Skeleton
            animation="wave"
            sx={{
              borderRadius: '15px',
              marginBottom: '4px',
              background: 'linear-gradient(to right,#ffffff, rgba(255,0,0,0))',
            }}
            width={85}
            height={11} />
          <Skeleton
            animation="wave"
            sx={{
              borderRadius: '30px ',
              background: 'linear-gradient(to right,#ffffff, rgba(255,0,0,0))',
            }}
            width={165}
            height={20} />
          <div className="d-flex gap-2" style={{ marginTop: '17px' }}>
            <Skeleton
              animation="wave"
              variant="rectangular"
              sx={{
                borderRadius: '27px',
                background:
                  'linear-gradient(to right,#ffffff, rgba(255,0,0,0))',
              }}
              width="100%">
              <div style={{ paddingTop: '75px' }} />
            </Skeleton>
            <Skeleton
              animation="wave"
              variant="rectangular"
              sx={{
                borderRadius: '27px',
                background:
                  'linear-gradient(to right,#ffffff, rgba(255,0,0,0))',
              }}
              width="100%">
              <div style={{ paddingTop: '75px' }} />
            </Skeleton>
          </div>
          <Skeleton
            animation="wave"
            sx={{
              borderRadius: '27px ',
              background: 'linear-gradient(to right,#ffffff, rgba(255,0,0,0))',
            }}
            width="100%"
            height={125} />
        </div>
      </div>

      <div style={isMob ? { padding: '20px' } : { paddingTop: '60px' }}>
        <Skeleton
          animation="wave"
          variant="rectangular"
          sx={{
            borderRadius: '27px',
            background: 'linear-gradient(to right,#f2f2f2,#fafafa )',
          }}
          width="100%">
          <div style={{ paddingTop: '325px' }} />
        </Skeleton>
      </div>
    </div>
  );
}

export default Shimmer;
